import { Collapse, Flex, Text } from '@chakra-ui/react';
import React, { useState } from 'react';
import styled from 'styled-components';

import IconComponent from '../../icon/icon';

interface DrawerMenuItemProps {
  text: string;
  icon?: JSX.Element;
  children?: JSX.Element | JSX.Element[];
}

const CustomText = styled(Text)`
  svg {
    display: inline;
  }
`;

export const DrawerSubmenuItem = ({ text, icon, children }: DrawerMenuItemProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => setIsOpen(!isOpen);

  return (
    <Flex
      direction="column"
      alignItems={'start'}
      marginY={'0.5rem'}
      padding={'0.5rem'}
      gap={'8px'}
      borderRadius="lg"
      color="#96999C"
      _hover={{ backgroundColor: 'var(--gray-90)', color: 'white' }}
      _focus={{ backgroundColor: 'var(--gray-90)', color: 'white' }}
    >
      <Flex alignItems={'center'} width="full" onClick={toggle}>
        {icon}
        <CustomText fontSize="16px" fontWeight="400">
          {text} <IconComponent name="minimalisticArrow" />
        </CustomText>
      </Flex>
      <Collapse in={isOpen} animateOpacity>
        {children}
      </Collapse>
    </Flex>
  );
};
